(function () {
  'use strict';
  if (window.palmrSignupBound) return;
  window.palmrSignupBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-palmr-signup]');
    if (!button) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', button.dataset.palmrSignup]);
  });
})();
